<tg-rack>
    <ng-container>
        <tg-rack-item ruled>
            <tg-rack-item-primary>
                <property-information-section></property-information-section>
            </tg-rack-item-primary>
        </tg-rack-item>
    </ng-container>
</tg-rack>
